import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { stats } from '../data/mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-16 sm:pt-20 md:pt-24 lg:pt-20">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc3NTc4NDk1M3ww&ixlib=rb-4.1.0&q=85"
          alt="Digital Marketing Team"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Content */}
          <div className="space-y-6 md:space-y-8">
            <div className="inline-flex items-center space-x-2 bg-white/80 backdrop-blur-sm px-3 py-2 sm:px-4 rounded-full border border-gray-200">
              <Sparkles className="w-3 h-3 sm:w-4 sm:h-4 text-gray-900" />
              <span className="text-xs sm:text-sm font-medium text-gray-900">Transforming Businesses Since 2013</span>
            </div>

            <h1 
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-gray-900 leading-tight"
              style={{ fontFamily: 'var(--font-serif)' }}
            >
              Customized Digital Solutions
              <span className="block text-gray-700">Tailored for Success</span>
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl" data-testid="hero-intro-sentence">
              iWurks360 provides digital marketing and IT services for businesses across Northwest Arkansas.
            </p>

            <p className="text-sm sm:text-base text-gray-700 leading-relaxed max-w-2xl" data-testid="hero-service-area">
              Serving Bentonville, Rogers, and Fayetteville, Arkansas with IT support and services, digital marketing, and business automation / AI solutions.
            </p>

            <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl">
              The renowned IT Solutions company providing for each client a customized and individually suited solution. 
              We build your business, increase your customer base, and boost revenue while cutting unnecessary capital expenditures.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => scrollToSection('contact')}
                style={{ backgroundColor: '#D97904' }}
                className="text-white hover:opacity-90 transition-all duration-200 px-6 py-5 sm:px-8 sm:py-6 text-base sm:text-lg group w-full sm:w-auto"
              >
                Start Your Transformation
                <ArrowRight className="ml-2 w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button 
                onClick={() => scrollToSection('case-studies')}
                variant="outline"
                style={{ borderColor: '#D97904', color: '#D97904' }}
                className="border-2 hover:bg-orange-600 hover:text-white transition-all duration-200 px-6 py-5 sm:px-8 sm:py-6 text-base sm:text-lg w-full sm:w-auto"
              >
                View Success Stories
              </Button>
            </div>
          </div>

          {/* Stats Card */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-200">
            <h3 
              className="text-xl sm:text-2xl font-bold text-gray-900 mb-6 sm:mb-8"
              style={{ fontFamily: 'var(--font-serif)' }}
            >
              Proven Track Record
            </h3>
            <div className="grid grid-cols-2 gap-4 sm:gap-6">
              {stats.map((stat) => (
                <div key={stat.id} className="text-center p-3 sm:p-4">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2">{stat.value}</div>
                  <div className="text-xs sm:text-sm text-gray-600 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
